import { DatabaseBackup, Layers, Mail, Plug, SlidersHorizontal } from "lucide-react";
import type { SideTab } from "@/components/shared";
import PlatformSettingsSection from "./PlatformSettingsSection";
import LevelSettingsSection from "./LevelSettingsSection";
import EmailSettingsSection from "./EmailSettingsSection";
import IntegrationsSection from "./IntegrationsSection";
import BackupSettingsSection from "./BackupSettingsSection";

/**
 * Settings registry. To add a settings section, build its component in this folder and
 * append an entry: it gets its own tab and URL (/admin/settings/<id>).
 */
export const settingsTabs: SideTab[] = [
  { id: "platform", label: "Platform Config", icon: SlidersHorizontal, render: () => <PlatformSettingsSection /> },
  { id: "levels", label: "Level Settings", icon: Layers, render: () => <LevelSettingsSection /> },
  { id: "email", label: "Email Settings", icon: Mail, render: () => <EmailSettingsSection /> },
  { id: "integrations", label: "Integrations", icon: Plug, render: () => <IntegrationsSection /> },
  { id: "backup", label: "Database Backup", icon: DatabaseBackup, render: () => <BackupSettingsSection /> },
];
